// Publish only with the speaker's approval.
export const testimonials: { id: string; quote: string; name: string; role: string; approved: boolean }[] = [];